module.exports = __webpack_public_path__ + "img/smartz-logo-black.ab6f5a99.svg";